import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function FrstPage() {
    const user = JSON.parse(localStorage.getItem('user-info'));

    return (
        <div className="account-pages my-5 pt-sm-5">
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <Container>
                            <Row className="justify-content-center">
                                <Col md={8} lg={6} xl={5}>
                                    <Card className="overflow-hidden shadow-lg border-0 rounded-4">
                                        <Card.Body className="pt-5 text-center">
                                            {/* <img 
                                                src="/images/welcome.svg" 
                                                alt="Welcome" 
                                                style={{width: '120px', marginBottom: '20px'}} 
                                            /> */}
                                            
                                            <h3 className="mt-3">
                                                Welcome {user?.name ? `, ${user.name}` : ''} 👋
                                            </h3>
                                            
                                            <p className="text-muted mt-2">
                                                Your account is active but you don’t have access to any dashboards yet.  
                                                This usually means your administrator is still setting up your permissions.
                                            </p>

                                            <p className="text-muted">
                                                Once permissions are assigned, you’ll see your dashboards here.
                                            </p>

                                            <button 
                                                className="btn btn-primary mt-3"
                                                onClick={() => {
                                                    localStorage.removeItem('user-info');
                                                    window.location.href = '/login';
                                                }}
                                            >
                                                Logout & Try Again
                                            </button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FrstPage;
